<template>
  <div>
    <v-toolbar
      dense
      dark
      color="blue darken-3"
      class="mb-1"
      v-if="items.length > 0"
    >
      <v-text-field
        v-model="search"
        clearable
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search / Name or Status"
        class="ma-4"
        dense
      ></v-text-field>
      <v-switch
        v-model="showMobile"
        label="Show Mobile"
        class="pt-4"
        dense
      ></v-switch>
    </v-toolbar>
    <!-- :single-select="singleSelect" -->

    <!-- <v-data-iterator
      :items="items"
      item-key="SearchName"
      hide-default-footer
      :items-per-page="100"
      :search="search"
    >
      <template v-slot:default="{ items }">
        <v-list>
          <v-list-item
            v-for="item in items"
            :key="item.SearchName"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            style="border: 1px solid grey"
            class="pl-2"
          >
            <v-list-item-action>
              <v-checkbox
                v-model="checked"
                :input-value="item"
                color="primary"
                @click="test(item, checked)"
              ></v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
              <v-chip color="#ffffff00" small>{{
                item.SearchName
              }}</v-chip></v-list-item-content
            >
            <v-list-item-content
              ><v-chip
                small
                style="min-width: 80px; max-width: 80px"
                :color="item.Color"
                dark
              >
                {{ item.Status }}
              </v-chip>
            </v-list-item-content>
            <v-list-item-content>
              <v-chip color="#ffffff00" small v-if="showMobile">{{
                item.MID
              }}</v-chip>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-data-iterator> -->

    <!-- ///////////////////// -->
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      :item-class="row_classes"
      item-key="RegId"
      show-select
      class="elevation-1"
      dense
      :search="search"
      disable-sort
      :items-per-page="-1"
    >
      <template v-slot:item.Status="{ item }">
        <v-chip small style="min-width: 80px" :color="item.Color" dark>
          {{ item.Status }}
        </v-chip>
      </template>
      <template v-slot:item.MID="{ item }">
        <v-chip color="#ffffff00" small v-if="showMobile">{{
          item.MID
        }}</v-chip>
      </template>
      <template v-slot:item.SearchName="{ item }">
        <v-chip color="#ffffff00" small>{{ item.SearchName }}</v-chip>
      </template>
    </v-data-table>
    <v-card>
      <!-- <pre>Pilots: {{ items }}</pre> -->
      <!-- <pre>{{ regId }}-{{ ac }}</pre> -->
      <!-- <pre>{{ selected }}</pre> -->
      <v-alert type="info" dense icon="fa-sms"> </v-alert>
      <v-spacer></v-spacer>
      <v-form v-model="isValid">
        <v-textarea
          v-model="compSmsText"
          outlined
          rounded
          required
          prepend-inner-icon="fa-sms"
          placeholder="Sms text"
          :rules="smsRules"
          max-length="155"
          hint="Sms text"
          counter
          clearable
          clear-icon="mdi-close-circle"
          class="px-4"
        ></v-textarea>
        <!-- <v-alert type="info" dense dismissible>{{ compComment }}</v-alert> -->
        <v-row align="center" justify="space-around">
          <!-- <v-col justify="center"> -->
          <!-- :disabled="!isValid" -->
          <v-btn
            small
            color="primary"
            rounded
            @click="sendSms"
            :disabled="!isValid"
          >
            SUBMIT
            <v-icon small right>fa-sms</v-icon>
          </v-btn>

          <!-- </v-col> -->
          <!-- <v-col justify="center"> -->
          <v-btn small rounded color="primary" :to="{ name: 'BoxList' }"
            >Cancel</v-btn
          >
          <copybutton :tocopy="compSmsText"></copybutton>
          <!-- </v-col> -->
        </v-row>
        <v-row><v-spacer></v-spacer></v-row>
      </v-form>
      <div>.</div>
      <v-alert type="success" :value="isAlertVisible" dense>
        {{ statusResultMsg }}
      </v-alert>
      <v-alert type="error" :value="isWarningAlertVisible" dense>
        {{ statusResultMsg }}
      </v-alert>
      <v-row><v-spacer></v-spacer>.</v-row>
      <ul v-if="errors && errors.length">
        <li v-for="error of errors" :key="error.id" style="color: Red">
          {{ error.message }}
        </li>
      </ul>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import copybutton from "@/components/Copy.vue";
// import { String } from "core-js";

export default {
  name: "SendEventSms",
  props: {
    items: {
      type: Array,
    },
    regId: Number,
    ac: String,
  },
  data() {
    return {
      //   compEventId: this.selectedEventId,
      //   compEventName: this.selectedEventName,
      //   compSmsText: this.smsText,
      //   compComment: this.comment,
      //   compRegId: this.regId,
      compSmsText: "",
      smsRules: [
        (v) =>
          (v.length <= 155 && v.length > 10) || "Min 10 - Max 155 characters",
      ],
      isAlertVisible: false,
      isWarningAlertVisible: false,
      errors: [],
      statuses: [],
      statusResult: Number,
      statusResultMsg: String,
      isValid: true,
      singleSelect: false,
      selected: [],
      selectedRegIds: {},
      headers: [
        { text: "", value: "SearchName" },
        { text: "", value: "Status" },

        { text: "", value: "MID" },

        // { text: "Status", value: "Status" },
        // { text: "Mobile", value: "MID" },
      ],
      search: "",
      showMobile: false,
      checked: false,
      //   pilots: [],
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.isValid = false;
    // console.log("SSM", this.props.pilots);
  },
  methods: {
    //   closeComponent() {
    //       this.$emit("closeComponent", false);
    //   },
    sendSms() {
      var regId = this.regId;
      var ac = this.ac;
      var msg = this.compSmsText;
      var toListOfRegId = "";
      var to = "";
      this.selected.forEach((item) => {
        to = to + item.RegId + ",";
      });
      toListOfRegId = to.slice(0, -1);
      //   var eventId = this.compEventId;
      //   var ac = this.ac;
      var toSubmit = JSON.stringify({ regId, ac, msg, toListOfRegId });

      const uri = this.baseUrl + "gwasmsmulti";
      //   console.log("uriSms: ", uri);
      //   console.log("toSubmitSms: ", toSubmit);
      this.isValid = false;
      this.postit(uri, toSubmit);
    },
    postit(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          console.log("smsRespons", response.data);
          this.statusResult = response.data.Result;
          this.statusResultMsg = response.data.ResultMsg;
          if (this.statusResult == undefined || this.statusResult == null) {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }

          this.setAlert(this.statusResult);
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    row_classes(item) {
      if (item.IsOddRow == 0) {
        return "odd-row"; //can also return multiple classes e.g ["orange","disabled"]
      }
      return "even-row";
    },
    test(item, checked) {
      console.log("test", item);
      console.log("checked", checked);
    },
  },
  components: {
    copybutton,
  },
};
</script>

<style>
.odd-row {
  background-color: #ebf1f0;
}
.even-row {
  background-color: #b0d0cb;
}
</style>